<template>
  <div class="ag-electives ag-policy-detail">
    <div class="row">
      <div class="col-md-12 main-content">
        <div class="appgroup-header">
          <h1>{{$t("appGroup")}} : <strong>{{$t("sqlServer")}}</strong></h1>
        </div>

        <div class="subheader">
          <div class="left">
            <span>{{$t("endpoint")}} : <strong>{{$t("sqlServer")}}</strong></span>
            <span
              >{{$t("generalProtections")}} :
              <strong>{{$t("riskUtilities")}}, {{$t("drivebyDownload")}}</strong></span
            >
          </div>
          <div class="right">
            <a href="" class="text-danger">{{$t("3NewAppGroups")}}</a>
            <a href="" class="text-danger">{{$t("10Newruleswaiting")}}</a>
          </div>
        </div>

        <div class="inner">
          <div class="inner-top">
            <div class="ag-dropdown mr-3">
              <button
                class="dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="ag-icon ag-icon_add_black"></i>
                {{$t("addBuildingBlock")}}
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="#">{{$t("systemSpaceExceptions")}} </a>
                <a class="dropdown-item" href="#">{{$t("systemSpaceProtection")}} </a>
                <a class="dropdown-item" href="#">{{$t("ransomwareProtection")}}</a>
                <a class="dropdown-item" href="#">{{$t("officeExceptions")}} </a>
                <a class="dropdown-item" href="#">{{$t("desktopINIExceptions")}} </a>
                <a class="dropdown-item" href="#"
                  >{{$t("networkPrinterExceptions")}}
                </a>
                <a class="dropdown-item" href="#">{{$t("networkShareExceptions")}} </a>
                <a class="dropdown-item" href="#">{{$t("WMIForbiddenChildren")}}</a>
              </div>
            </div>

            <span class="ag-label warning mr-3">
              <span>{{$t("systemSpaceExceptions")}} </span>
              <a href="#" class="close">x</a>
            </span>
            <span class="ag-label warning">
              <span>{{$t("standardContainment")}} </span>
              <a href="#" class="close">x</a>
            </span>
          </div>

          <div class="body">
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-12 mb-4">
                    
                    <button class="btn btn-spm btn-spm-primary float-right">
                      <i class="ag-icon mr-1 ag-icon_add"></i>
                      {{$t("createanAppGroup")}}
                    </button>
                    <router-link
                      :to="{ name: 'top-level-electives' }"
                      class="btn btn-spm float-right mr-2"
                    >
                      <i class="ag-icon ag-icon_tune_black"></i>
                      {{$t("listView")}}
                    </router-link>
                  </div>
                  <div class="col-md-4">
                    <div class="data-section">
                      <h3>
                        <i class="ag-icon ag-icon_public_black"></i>{{$t("globalPolicy")}}
                      </h3>

                      <div class="data-content">
                        <a href="#" class="data-box dark-gray">
                          <i class="ag-icon ag-icon_public_black"></i>
                          {{$t("protections")}}
                        </a>
                        <a href="#" class="data-box gray">
                          <i class="ag-icon ag-icon_public_black"></i> {{$t("powerApps")}}
                        </a>
                        <a href="#" class="data-box gray">
                          <i class="ag-icon ag-icon_public_black"></i>{{$t("redListed")}}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-8">
                    <div class="data-section">
                      <h3>
                        <i class="ag-icon ag-icon_security_black"></i> {{$t("appGroups")}}
                      </h3>

                      <div class="data-content">
                        <a href="#" class="data-box blue">
                          <div class="inner">
                            {{$t("office")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box blue">
                          <div class="inner">
                            SQL
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box blue">
                          <div class="inner">
                            {{$t("riskyApplications")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box blue">
                          <div class="inner">
                            {{$t("passtheHash")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box blue">
                          <div class="inner">
                            {{$t("WMI")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box brown">
                          <div class="inner">
                            {{$t("Skype")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box brown">
                          <div class="inner">
                            {{$t("Thunderbird")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                        <a href="#" class="data-box yellow">
                          <div class="inner">
                            {{$t("customAppGroups")}}
                            <small class="bottom-label">{{$t("topLevel")}}</small>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex flex-column align-items-center">
                  <p class="badge badge-success ag-badge w-100">
                    V.6.2 Published
                  </p>
                  <small>{{$t("showPolicy")}}</small>
                </div>

                <div class="link-groups">
                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_settings_black"></i>
                    {{$t("applicationIndex")}}
                  </router-link>
                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                    disabled
                  >
                    <i class="ag-icon ag-icon_policies"></i>
                    {{$t("observeBlock")}}
                  </router-link>
                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_tune_black"></i>
                    {{$t("versionChanges")}}
                  </router-link>

                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_tune_black"></i>
                    {{$t("setEnforcement")}}
                  </router-link>

                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_security_black"></i>
                    {{$t("setProtection")}}
                  </router-link>

                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_tune_black"></i>
                    {{$t("manageElectives")}}
                  </router-link>

                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_settings_black"></i>
                    {{$t("groupSettings")}}
                  </router-link>

                  <router-link
                    :to="{ name: 'top-level-electives' }"
                    class="btn btn-spm"
                  >
                    <i class="ag-icon ag-icon_tune_black"></i>
                    {{$t("publishPolicyBlock")}}
                  </router-link>

                  <p class="version text-center mt-5">
                    {{$t("agentversion")}}: 5.2.4.1 <br />
                    {{("installerVersion")}}: 3.9
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tree from "vuejs-tree";
import Swal from "sweetalert2";

export default {
  name: "TopLevelElectives",
  components: {
    // Tree: Tree,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    deleteItem() {
      Swal.fire({
        title: "Are You Sure?",
        text: "You are about to delete item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        alert("deleted");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-electives {
  border-top: 3px solid #d2d6de;
  margin-bottom: 10px;
  .row {
    margin: 0px;
  }

  .navigation {
    padding-right: 0px;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font: normal normal normal 15px/23px Open Sans;
      letter-spacing: 0px;
      color: #576271;
      background: #fff;
      border-bottom: 2px solid #7294a8;

      .header-tab-item {
        width: 50%;
        // padding: 12px 32px;
        line-height: 50px;
        color: #576271;
        text-align: center;
        &.selected {
          font: normal normal bold 15px/23px Open Sans;
          letter-spacing: 0px;
          line-height: 50px;
          color: #ffffff;
          background: #7294a8 0% 0% no-repeat padding-box;
        }
      }
    }

    .body {
      .endpoint-types {
        background: #42c2cc15 0% 0% no-repeat padding-box;
      }

      .appgroups {
        background: #ffc56215 0% 0% no-repeat padding-box;
      }

      .general {
        background: #bf310015 0% 0% no-repeat padding-box;
      }

      .building-blocks {
        background: #42cc9715 0% 0% no-repeat padding-box;
      }
    }
  }

  .main-content {
    padding-left: 0px;
    padding-right: 0px;

    background: #f8f8f8 0% 0% no-repeat padding-box;

    .appgroup-header {
      background: #faedd4 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      padding: 12px;
      box-shadow: 0px 3px 6px #00000029;

      h1 {
        text-align: left;
        font: normal normal 600 31px/42px Open Sans;
        letter-spacing: 0px;
        color: #b7c6cd;

        strong {
          font: normal normal 600 31px/42px Open Sans;
          letter-spacing: 0px;
          color: #7294a8;
        }
      }
    }

    .inner {
      padding: 12px;

      .inner-top {
        margin-bottom: 24px;
        display: flex;
        align-items: center;
      }

      .tab {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #d9d9d9;
        margin: 0px;
        padding: 0px;

        li {
          display: flex;
          align-items: center;
          margin-right: 32px;

          &.right {
            align-items: flex-end;
            float: right;
            margin-left: auto;
            a {
              flex-direction: row;
              align-items: center;
              font-size: 14px;

              i {
                margin-right: 6px;
                margin-top: 3px;
              }
            }
          }

          &.selected {
            a {
              text-align: center;
              font: normal normal bold 18px/24px Open Sans;
              letter-spacing: 0px;
              color: #4c8dbb;
              padding-bottom: 8px;
              border-bottom: 4px solid #1878af;
              margin-bottom: -2px;
            }
          }

          a {
            text-align: center;
            font: normal normal normal 18px/24px Open Sans;
            letter-spacing: 0px;
            color: #4c8dbb;
            display: flex;
            flex-direction: column;
            align-items: center;

            &:hover {
              text-decoration: none;
            }

            i {
              margin-bottom: 8px;
            }
          }

          a.add-new {
            display: flex;
            flex-direction: row;
            font-size: 14px;
          }
        }
      }

      .body {
        margin-top: 40px;
      }
    }
  }

  &.ag-policy-detail {
    .appgroup-header {
      background: #d9dee2 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      padding: 12px;
      box-shadow: 0px 3px 6px #00000029;
    }

    .link-groups {
      padding: 16px 36px;
      margin-top: 16px;
    }

    small {
      font-size: 11px;
      color: #a7a8a8;
    }

    p.version {
      color: #a7a8a8;
    }

    .subheader {
      background: #edeff2;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 3px 6px #00000029;

      a {
        margin-right: 16px;
      }
      span {
        color: #aab9c5;
        margin-right: 16px;

        strong {
          color: #7993a6;
        }
      }
    }

    .data-section {
      background: #edeff1;
      border: 2px solid #e1e5e8;
      border-radius: 28px;
      padding: 18px;

      h3 {
        display: flex;
        align-items: center;
        color: #264a69;
        font-size: 24px;

        i {
          margin-right: 6px;
        }
      }

      .data-content {
        margin-top: 32px;
        display: flex;
        flex-wrap: wrap;

        .data-box {
          border-radius: 12px;
          box-shadow: 0px 3px 6px #00000029;

          display: flex;
          align-items: center;
          text-align: center;
          padding: 56px 44px;
          margin-bottom: 16px;
          text-decoration: none;
          font-size: 18px;
          flex-basis: 170px;
          width: 170px;
          margin-right: 12px;
          flex-grow: 1;
          position: relative;

          .inner {
            text-align: center;
            display: block;
            width: 100%;
          }

          .bottom-label {
            bottom: 6px;
            right: 8px;
            position: absolute;
            color: #fff;
          }

          &:hover {
            background-color: #d9dfe2 !important;
            color: #7993a6 !important;
          }

          i {
            margin-right: 6px;
          }

          &.blue {
            background-color: #359fe0;
            color: #fff;
          }

          &.gray {
            background-color: #d9dfe2;
            color: #7993a6;
          }

          &.dark-gray {
            background-color: #7a93a5;
            color: #fff;
          }

          &.yellow {
            background-color: #f5bf59;
            color: #fff;
          }

          &.brown {
            background-color: #b2a080;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
